import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";
import PageLoader from "../../../../../../components/PageLoader";
import {orderData} from '../reconciliations'

import { updateNestedValue } from "../../../../../../common/services/common.service";
import { MdTableView } from "react-icons/md";
import { reconciliations } from "../../../../../../redux/settlement-hub/reconciliations/action";
import { selectReconciliationCreatedItem, selectReconciliationDeletedItem, selectReconciliationsListItems, selectReconciliationUpdatedItem } from "../../../../../../redux/settlement-hub/reconciliations/selector";
import { ReconciliationPopup } from "../components/reconciliation-popup.component";
import { ReconciliationItemsPopup } from "../../reconciliation-items/containers/reconciliation-items-popup";
import { libraryData } from "../../constants/constants";

const Reconciliations = ({
  
}: any) => {

  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showReconciliationPopup, setShowReconciliationPopup] = useState<boolean>(false);
  const [showReconciliationItemsPopup, setShowReconciliationItemsPopup] = useState<boolean>(false);
  const [selectedReconciliation, setSelectedReconciliation] = useState<any>({
    "Id": 0,
    "OrderId": 0,
    "amount": 0,
    "Remarks": ""
  });

  const [listItems, setListItems] = useState<any>([]);
  const listOfReconciliationsData = useSelector(selectReconciliationsListItems)
  const createReconciliationRequestsData = useSelector(selectReconciliationCreatedItem)
  const updateReconciliationRequestsData = useSelector(selectReconciliationUpdatedItem)
  const deleteReconciliationsRequestsData = useSelector(selectReconciliationDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'OrderId', headerName: 'Order Id', sortable: true, filter: true, filterType: 'text', },
      { field: 'Amount.Value', headerName: 'Amount', sortable: true, filter: true, filterType: 'number', },
      { field: 'ReconciliationStatusId', headerName: 'Status', sortable: true, filter: true, filterType: 'text', cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData, menuKey: 'Value', menuValue: 'Description', callback: handleStatus, anchorPosition: 'top-left' },
      },
      {field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: 'UpdatedOnUtc', headerName: 'Updated On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: '', headerName: 'Items', sortable: false, filter: false, cellRenderer: 'customFunctions'},

    ]);
  }

  const handleStatus = () => {

  }

  const handleInnerFormChange: any = ({path, value}: any) => {
    console.log('selectedReconciliation, path, value', selectedReconciliation, path, value)
    const updatedData = updateNestedValue(selectedReconciliation, path, value)

    console.log('updatedData', updatedData)
    setSelectedReconciliation({...updatedData});
  }

  const handleAddReconciliation = () => {    
    setSelectedReconciliation({
      "Id": 0,
      "OrderId": 0,
      "amount": 0,
      "Remarks": ""
      })
    setShowReconciliationPopup(true)
  }

  const handleInitiateReconciliation = () => {
    
  }

  const handleReconciliation = () => {

  }

  const handleEdit = (data: any) => {
    setSelectedReconciliation(data)
    setShowReconciliationPopup(true)
  }

  const handleDelete = async (data: any) => {
    console.log('delete item', data)
    // const ids = _.map(data, (item: any) => {return {Id: item?.ReconciliationRequest?.Id}})
    // console.log('ids',ids)
    await dispatch(reconciliations.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliations/delete`,
      entity: 'reconciliations',
      jsonData: {
        Context:{},
        Records: [{Id: data?.ReconciliationRequest?.Id}]
      }
    }));
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Reconciliation</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add Reconciliation',
      callback: () => handleAddReconciliation(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleReconciliationItems =(item: any) => {
    setShowReconciliationItemsPopup(true)
  }

  const customFunctions = [
    {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleReconciliationItems, title: "Show Reconciliation Items"},
    // {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleSpecificationAttributeOptions, title: "Show Specification Attribute Options"},
  ];

  const handleReloadData = () => {
    listReconciliations();
  }

  const listReconciliations = async () => {
    console.log('reconciliations')
    await dispatch(reconciliations.resetAction({actionType:'list'}))
    await dispatch(reconciliations.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliations/list`,
      entity: 'reconciliations',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSaveReconciliation = async (selectedReconciliation: any) => {
    if (selectedReconciliation?.Id > 0) {
      await dispatch(reconciliations.resetAction({actionType:'update'}))
      await dispatch(reconciliations.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliations`, entity: 'reconciliations', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedReconciliation
              }]
            }
          ]
        }
      }))
    } else {
      await dispatch(reconciliations.resetAction({actionType:'update'}))
      await dispatch(reconciliations.create({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliations`, entity: 'reconciliations', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedReconciliation
              }]
            }
          ]
        }
      }))
    }
    closeModal();
    listReconciliations();
  }

  const closeModal = () => {
    setShowReconciliationPopup(false)
  }

  const closeItemsModal = () => {
    setShowReconciliationItemsPopup(false)
  }

  useEffect(() => {
    console.log('listOfReconciliationsData', listOfReconciliationsData)
    // if(listOfReconciliationsData?.isSuccess){
      if(listOfReconciliationsData?.result?.items && listOfReconciliationsData?.result?.items?.length > 0)
      {
        console.log('listOfReconciliationsData?.result?.items[0].Error', listOfReconciliationsData?.result?.items[0].Error)
        if (listOfReconciliationsData?.result?.items[0].Error){
          setListItems(orderData)          
        }   
        else {
          setListItems(listOfReconciliationsData?.result?.items)
        }     
      }  else {
        setListItems(orderData)
      }    
    // }
  }, [listOfReconciliationsData]);

  // useEffect(() => {
  //   setListItems(orderData)
  // }, []);

  useEffect(() => {
    console.log('list items', listItems)
  
  }, [listItems]);

  useEffect(() => {
    listReconciliations();
  }, [deleteReconciliationsRequestsData]);

  useEffect(() => {
    createColumnDefs()
    listReconciliations()
  }, [pageData, pageSize])

  return (
    <>
      {
        showReconciliationPopup ?
          <ReconciliationPopup
            selectedReconciliation={selectedReconciliation}
            closeModal={closeModal}
            handleSaveReconciliation={handleSaveReconciliation}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }
      {
        showReconciliationItemsPopup ?
          <ReconciliationItemsPopup
            selectedReconciliation={selectedReconciliation}
            closeModal={closeItemsModal}
            handleSaveReconciliation={handleSaveReconciliation}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }
      {listOfReconciliationsData?.isLoading || deleteReconciliationsRequestsData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={listItems}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listOfReconciliationsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          customFunctions={customFunctions}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }} 
          headingName="Reconciliations" />
      }
    </>
  );
};

export default Reconciliations;


